<template>
  <div class="team-experiences-page">
    <!-- Hero Section -->
    <!-- Team Gallery Section -->
    <div class="team-gallery">
      <div class="gallery-grid">
        <div class="gallery-item center">
          <NuxtImg
            :src="baseUrl + `travvir-group2.jpg`"
            alt="Team collaboration"
          />
          <div class="gradients"></div>
        </div>
        <div class="gallery-item top-left">
          <NuxtImg :src="baseUrl + `priyam2.jpg`" alt="Team meeting" />
          <div class="gradients"></div>
        </div>
        <div class="gallery-item top-right">
          <NuxtImg
            :src="baseUrl + `travvir-group3.jpg`"
            alt="Team celebration"
          />
          <div class="gradients"></div>
        </div>
        <div class="gallery-item bottom-left">
          <NuxtImg :src="baseUrl + `gourav.jpg`" alt="Team member" />
          <div class="gradients"></div>
        </div>
        <div class="gallery-item bottom-right">
          <NuxtImg :src="baseUrl + `ajay.jpg`" alt="Team outing" />
          <div class="gradients"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRuntimeConfig } from "nuxt/app";

const config = useRuntimeConfig();
const baseUrl = config.public.NUXT_CDN_URL + `/static/website/`;
</script>
<style lang="scss" scoped>
.team-experiences-page {
  background: #000;
  color: #fff;
  min-height: fit-content;
  @include respond-below(sm) {
  }
}
.team-gallery {
  padding: 4rem 2rem 6rem;
  max-width: 1400px;
  margin: 0 auto;

  @include respond-below(md) {
    padding: 3rem 1.5rem 4rem;
  }

  @include respond-below(sm) {
    padding: 2rem 1rem 3rem;
  }
}

.gallery-grid {
  position: relative;
  width: 100%;
  height: fit-content;
  min-height: 850px;

  @include respond-below(lg) {
    height: 70vh;
    min-height: 500px;
  }

  @include respond-below(md) {
    height: 60vh;
    min-height: 450px;
  }

  @include respond-below(sm) {
    height: 65vh;
    min-height: 600px;
  }
}

.gallery-item {
  position: absolute;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .gradients {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // pointer-events: none; // Ensure it doesn't interfere with interactions
    // mix-blend-mode: screen; // Blend mode for better visual effect
  }

  &.center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: clamp(300px, 35vw, 550px);
    height: calc(400px / 0.749322493);
    height: clamp(calc(200px / 0.749322493), 25vw, calc(380px / 0.749322493));
    z-index: 2;
    @include respond-below(md) {
      width: clamp(250px, 40vw, 400px);
      height: clamp(170px, 28vw, 280px);
    }

    @include respond-below(sm) {
      width: clamp(280px, 59vw, 350px);
      height: clamp(calc(150px / 0.749322493), 35vw, calc(190px / 0.749322493));
      top: 47%;
    }
  }

  &.top-left {
    top: 5%;
    left: 7%;
    width: clamp(150px, 18vw, 240px);
    height: clamp(calc(150px / 0.75), 18vw, calc(215px / 0.75));
    z-index: 2;
    @include respond-below(md) {
      width: clamp(120px, 20vw, 180px);
      height: clamp(120px, 20vw, 180px);
      top: 8%;
      left: 5%;
    }

    @include respond-below(sm) {
      // width: clamp(80px, 3vw, 120px);
      width: clamp(120px, 35vw, 160px);
      height: clamp(calc(130px / 0.75), 38vw, calc(180px / 0.75));
      top: 0%;
    }
  }

  &.top-right {
    top: 5%;
    right: 10%;
    width: clamp(190px, 24vw, 320px);
    height: clamp(calc(180px / 0.75), 22vw, calc(280px / 0.75));
    z-index: 4;

    @include respond-below(md) {
      width: clamp(140px, 25vw, 220px);
      height: clamp(140px, 25vw, 220px);
      top: 8%;
      right: 5%;
    }

    @include respond-below(sm) {
      width: clamp(120px, 48vw, 220px);
      height: clamp(calc(130px / 0.75), 43vw, calc(180px / 0.75));
      top: 0%;
      right: -1%;
    }
  }

  &.bottom-left {
    bottom: 3%;
    left: 3%;
    width: clamp(160px, 20vw, 270px);
    height: clamp(calc(160px / 0.562584118), 28vw, calc(270px / 0.562584118));
    z-index: 1;

    @include respond-below(md) {
      width: clamp(120px, 22vw, 200px);
      height: clamp(160px, 30vw, 280px);
      bottom: 0%;
    }

    @include respond-below(sm) {
      width: clamp(140px, 40vw, 200px);
      height: clamp(calc(130px / 0.5621), 10vw, calc(200px / 0.5621));
      bottom: -4%;
      left: 0%;
    }
  }

  &.bottom-right {
    bottom: -2%;
    right: 3%;
    width: clamp(160px, 20vw, 270px);
    height: clamp(calc(200px / 0.750112158), 28vw, calc(320px / 0.750112158));
    z-index: 1;

    @include respond-below(md) {
      width: clamp(120px, 22vw, 200px);
      height: clamp(160px, 30vw, 280px);
      bottom: -10%;
    }

    @include respond-below(sm) {
      width: clamp(145px, 40vw, 200px);
      height: clamp(calc(180px / 0.7501), 35vw, calc(200px / 0.7501));
      bottom: -4%;
      right: 0%;
    }
  }
}
</style>
